import React, { useState } from 'react';
import Navbar from './Navbar';
import OrganizationPricing from '../Organization/OrganizationPricing';
import PortosFooter from './PortosFooter';
import 'react-phone-input-2/lib/style.css';
import './LandingPage.css';
import PhoneInput from 'react-phone-input-2';
import { base_url } from '../../utilities';
import axios from 'axios';
import AlertPopUp from '../Reusable_Components/Alert';

export default function LandingPage() {
    const [alertShow, setAlertShow] = useState(false)
    const [alertType, setAlertType] = useState('')
    const [alertMessage, setAlertMessage] = useState('')
    const [alertValue, setAlertValue] = useState('')
    const [alertButtons, setAlertButtons] = useState([])


    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [companyEmail, setCompanyEmail] = useState("");
    const [industry, setIndustry] = useState("");
    const [phoneCountryCode, setPhoneCountryCode] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [fullPhoneNumber, setFullPhoneNumber] = useState("");

    const backFunction = () => {
        setAlertShow(false);
        setAlertType("");
        setAlertMessage("");
        setAlertValue("");
        setAlertButtons([]);
        setFirstName("");
        setLastName("");
        setCompanyName("");
        setCompanyEmail("");
        setIndustry("");
        setFullPhoneNumber(phoneCountryCode)
        setPhoneNumber("")
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const data = {
            "first_name": firstName,
            "last_name": lastName,
            "company_name": companyName,
            "company_email": companyEmail,
            "industry": industry,
            "phone_country_code": "+" + phoneCountryCode,
            "phone_number": phoneNumber
        }
        axios.post(base_url + "subscription/contactSubmission", data).then((res) => {

            setAlertShow(true);
            setAlertType("success");
            setAlertMessage("Success");
            setAlertValue("Request submitted successfully. Our sales team will get in touch with you soon.");
            setAlertButtons([
                {
                    name: "Close",
                    action: () => {
                        setAlertShow(false);
                        backFunction();
                    }
                }
            ]);

        }
        ).catch((err) => {
            setAlertShow(true);
            setAlertType("error");
            setAlertMessage("Error submitting form");
            setAlertValue(err?.response?.data?.message);
            setAlertButtons([
                {
                    name: "Close",
                    action: () => {
                        setAlertShow(false);
                        backFunction();
                    }
                }
            ]);
        })
    }
    return (
        <>
            <Navbar />
            <AlertPopUp alertShow={alertShow} alertType={alertType} alertMsg={alertMessage} alertValue={alertValue} alertButtons={alertButtons} />

            <section className="landing-page" id='hero'>
                <div className="landing-left">
                    <img src='./images/icons/heroImage.png' alt="Worker at port" />
                </div>
                <div className="landing-right">
                    <span style={{ fontSize: "12px", color: "#2D3748", padding: "3px 12px", borderRadius: "20px", border: "2px solid rgb(235, 235, 235)", width: "fit-content", marginBottom: "10px", backgroundColor: "white" }}>
                        A Warehouse and Facility Management Software
                    </span>
                    <h1 style={{ fontSize: "80px" }}><span className="bold">Port</span><span className="gradient">OS</span></h1>
                    <p>
                        Simplify today, scale tomorrow with<br />
                        smart cargo & warehousing business solutions.
                    </p>
                    <a href="#features" style={{ textDecoration: "none" }}><button className="cta-button">Explore more</button></a>
                    <div className="mini-gallery">
                        <img src='./images/icons/warehouseImage.png' alt="Warehouse workers" />
                        <img src="./images/icons/facilityManagerPortos.png" alt="Shipping containers" />
                        <img src="./images/icons/loadingImage.png" alt="Cargo loading dock" />
                    </div>
                </div>
            </section>

            <section className="features-section" id='features'>
                <h2 className="features-heading">
                    <span className="light">Your Operations,</span><br />
                    <span className="bold">Streamlined to Perfection</span>
                </h2>
                <p className="features-subtext">
                    PortOS is built for industries where precision and efficiency drive success. From cargo terminals, and warehouses to property management, it seamlessly manages space licenses, utility services, and financial workflows, all in one platform. Whether you’re handling large-scale facilities or multi-location operations, PortOS transforms complexity into clarity.
                </p>

                <div className="features-grid">
                    <div className="feature-card">
                        <img src="./images/icons/homePageDigitalMeter.svg" alt="Meter Icon" />
                        <h4 style={{ color: "#2D3748" }}>DIGITIZED METER READING</h4>
                        <p>PortOS ensures seamless capture and validation of meter readings with exceptional accuracy.</p>
                    </div>
                    <div className="feature-card">
                        <img src="./images/icons/smartInvoice.svg" alt="Invoice Icon" />
                        <h4 style={{ color: "#2D3748" }}>SMART INVOICE MANAGEMENT</h4>
                        <p>Automate invoice creation, delivery and tracking ensuring every bill is on-time and in-line with contractual terms.</p>
                    </div>
                    <div className="feature-card">
                        <img src="./images/icons/smartEventManagement.svg" alt="Event Icon" />
                        <h4 style={{ color: "#2D3748" }}>SEAMLESS EVENT MANAGEMENT</h4>
                        <p>Built-in scheduling and alerts ensure you never miss a critical task - whether it's a maintenance check, or contract renewal.</p>
                    </div>
                    <div className="feature-card">
                        <img src="./images/icons/gstPortalIntegration.svg" alt="GST Icon" />
                        <h4 style={{ color: "#2D3748" }}>GST PORTAL INTEGRATION</h4>
                        <p>PortOS integrates directly with GST portals, automating tax-compliant invoice generation and submission.</p>
                    </div>
                    <div className="feature-card">
                        <img src="./images/icons/gstPortalIntegration.svg" alt="Compliance Icon" />
                        <h4 style={{ color: "#2D3748" }}>REPORTING & COMPLIANCE</h4>
                        <p>PortOS integrates directly with GST portals, automating tax-compliant invoice generation and submission.</p>
                    </div>
                </div>
            </section>
            <section className="event-management-section" >
                <div className="event-management-container">
                    <div className="event-management-image">
                        <img src="./images/icons/digitizedMeter.jpg" alt="Meter Reading Device" />
                    </div>
                    <div className="event-management-text">
                        <h2 style={{ color: "#2D3748" }}>Digitized Meter Reading</h2>
                        <h4 className="subheading">Precision tracking, without the manual overhead</h4>
                        <p>
                            PortOS streamlines utility tracking by digitising meter readings across sites, eliminating manual errors and delays.
                            Built-in validations, automatic unit conversions, and anomaly detection ensure data accuracy from capture to billing.
                        </p>
                        <p>
                            With seamless integration into invoicing workflows, enterprises gain faster reconciliations, fewer disputes, and scalable oversight across locations.
                        </p>
                    </div>
                </div>
            </section>
            <section className="smart-invoice-section">
                <div className="smart-invoice-container">
                    <div className="smart-invoice-text">
                        <h2 style={{ color: "#2D3748" }}>Smart Invoice Management</h2>
                        <p className="subheading">On-time, error-free billing at scale</p>
                        <p>
                            PortOS automates invoice creation, delivery and tracking,
                            ensuring every bill is accurate and aligned with contractual terms.
                        </p>
                        <p>
                            By syncing with metering data and lease agreements, it shortens payment cycles,
                            eliminates manual effort and keeps all stakeholders in the loop with complete transparency.
                        </p>
                    </div>
                    <div className="smart-invoice-image">
                        <img src="./images/icons/smartInvoiceImage.jpg" alt="Invoice on laptop" />
                    </div>
                </div>
            </section>
            <section className="event-management-section">
                <div className="event-management-container">
                    <div className="event-management-image">
                        <img src="./images/icons/eventManagementImage.jpg" alt="Event Management Workflow" />
                    </div>
                    <div className="event-management-text">
                        <h2 style={{ color: "#2D3748" }}>Seamless Event Management</h2>
                        <p className="subheading">Stay on top of every deadline, effortlessly</p>
                        <p>
                            PortOS helps you track critical tasks like maintenance checks, contract renewals,
                            and scheduled activities through a unified calendar.
                        </p>
                        <p>
                            Built-in scheduling tools, automated alerts and reminders ensure nothing slips
                            through the cracks. Whether it's a routine inspection or a lease milestone,
                            you’re always on time and fully in control.
                        </p>
                    </div>
                </div>
            </section>
            <section className="gst-portal-section pb-3 mb-0">
                <div className="gst-portal-container">
                    <div className="gst-text">
                        <h2 style={{ color: "#2D3748" }}>GST Portal Integration</h2>
                        <p className="subheading">Frictionless compliance, built in</p>
                        <p>
                            PortOS connects directly with the GST portal to auto-sync relevant invoice data, simplifying
                            tax submissions and reducing compliance risk.
                        </p>
                        <p>
                            By eliminating manual uploads and ensuring real-time validation, the system helps you stay
                            audit-ready while cutting down time spent on reconciliations. No more GST mismatches or
                            last-minute scrambles.
                        </p>
                    </div>

                    <div className="gst-visual mb-1">
                        <div className="gst-info">
                            <p className="highlight-text">Save time with integrated<br />GST-compliant Invoicing</p>
                            <a href='#pricing'><button className="demo-btn">Book a Demo</button></a>
                        </div>
                        <div className="invoice-img">
                            <img className='mt-0' src="./images/icons/invoiceImage.jpg" alt="Tax Invoice" />
                        </div>
                    </div>
                </div>
            </section>
            <OrganizationPricing />
            <section class="templates-section">
                <h2 className='template-text'>Customizable. Compliant. Client-Ready.</h2>
                <div class="templates-grid">
                    <div class="template-item">
                        <img src="images/icons/customForm.jpg" alt="Custom Form" />
                        <h3 >Custom Forms</h3>
                        <p className='template-text'>
                            Design operational workflows with flexible, easy-to-use form templates that adapt to your business processes.
                        </p>
                    </div>
                    <div class="template-item">
                        <img src="images/icons/sopTemplate.jpg" alt="SOP Template" />
                        <h3 >SOP Templates</h3>
                        <p className='template-text'>
                            Standardize procedures across teams with customizable SOP templates that promote consistency, clarity, and compliance.
                        </p>
                    </div>
                    <div class="template-item">
                        <img src="images/icons/invoiceTemplate.jpg" alt="Invoice Template" />
                        <h3 >Invoice Templates</h3>
                        <p className='template-text'>
                            Use branded, client-specific invoice templates to deliver transparent, professional, and compliant billing on your terms.
                        </p>
                    </div>
                </div>
            </section>
            <section class="efficiency-section">
                <div class="efficiency-header">
                    <h2 >Built for <span>Efficiency</span></h2>
                    <p className='template-text'>
                        From managing assets and AMCs to tracking safety readiness and fire drills, PortOS
                        takes care of the groundwork, so you can focus on scaling your business.
                    </p>
                </div>

                <div class="efficiency-grid">
                    <div class="efficiency-card">
                        <img src="images/icons/efficiency1.jpg" alt="Track Every Contract" />
                        <h4 className='d-flex justify-content-center ' style={{ color: "#2D3748" }}>SPACE LICENSE MANAGEMENT</h4>
                        <h3 className='d-flex justify-content-center r' style={{ textAlign: "center", color: "#2D3748" }}>Track Every Contract,<br />From Initial Execution to Renewal</h3>
                        <p style={{ textAlign: "justify" }} className='template-text'>
                            PortOS ensures your space licenses are managed with clarity and control.
                            Digitize and manage contracts easily, ensuring agreements are tracked across their lifecycle,
                            eliminating the risks of manual processes.
                        </p>
                    </div>

                    <div class="efficiency-card">
                        <img src="images/icons/efficiency2.jpg" alt="Establish Infrastructure" />
                        <h4 className='d-flex justify-content-center '>FACILITIES ONBOARDING</h4>
                        <h3 className='d-flex justify-content-center ' style={{ color: "#2D3748" }}>Establish Infrastructure<br />for Unmatched Success</h3>
                        <p style={{ textAlign: 'justify' }} className='template-text'>
                            PortOS connects your utility assets—energy meters, water meters, and beyond—into
                            a single operational platform. Monitoring and billing for facility resources become
                            effortless, paving the way for accuracy and operational transparency.
                        </p>
                    </div>
                </div>
            </section>
            <section className="team-section">
                <div className="overlay"></div>
                <div className="team-content">
                    <div className="text-box">
                        <h2>
                            Designed for <br />
                            <span>Your Team</span>
                        </h2>
                        <p className='template-text'>
                            PortOS delivers an experience designed for every role, from technicians to facility managers,
                            and finance managers to CEOs. Intuitive interfaces and role-based access ensure users can
                            easily manage workflows, track tasks, and analyze data.
                        </p>
                        <a href='#pricing' style={{ textDecoration: "none" }}><button className="demo-button">Book a Demo</button></a>
                    </div>
                </div>
            </section>
            <section class="compliance-section">
                <div class="compliance-container">
                    <div class="compliance-image">
                        <img src="images/icons/complianceImage.jpg" alt="Compliance" />
                    </div>
                    <div class="compliance-text">
                        <h2 style={{ color: "#2D3748" }}>
                            Compliance<br />
                            <span>Without Compromise</span>
                        </h2>
                        <p>
                            PortOS ensures adherence to industry standards like ISO27001, offering robust data
                            security and reliability. With a scalable architecture, it seamlessly supports
                            multi-site operations and regional expansions, empowering businesses to grow
                            confidently and securely.
                        </p>
                    </div>
                </div>
            </section>
            <section>
                <div className="industry-banner">
                    <div className="overlay">
                        <h1>
                            TAILORMADE FOR <span className="highlight">YOUR INDUSTRY</span>
                        </h1>
                        <button className="learn-more-btn">Learn More</button>
                    </div>
                </div>
            </section>
            <section class="data-decision-allinone">
                <div class="data-left">
                    <h2 style={{ color: "#2D3748" }}>
                        From <span class="bold">Data</span><br />
                        to <span class="bold">Decisions</span>
                    </h2>
                    <h4 class="subheading">ALL IN ONE PLACE</h4>
                    <p>
                        PortOS transforms your data into actionable insights. It helps track performance,
                        optimize operations, and plan strategically—tailored to your business needs.
                    </p>
                </div>

                <div class="data-right">
                    <div class="feature">
                        <img src="https://img.icons8.com/ios/50/line-chart.png" alt="Detailed Reports" />
                        <div>
                            <h3 style={{ color: "#2D3748" }}>Detailed Reports</h3>
                            <p>Gain granular insights into utility usage, billing trends, and contract compliance, empowering data-driven decisions.</p>
                            {/* <a href="#" style={{ color: 'gray' }}>Show More</a> */}
                        </div>
                    </div>

                    <div class="feature">
                        <img src="https://img.icons8.com/ios/50/combo-chart.png" alt="Real-Time Dashboards" />
                        <div>
                            <h3 style={{ color: "#2D3748" }}>Real-Time Dashboards</h3>
                            <p>Monitor key metrics, including overdue invoices and resource utilization, with live updates for a clear operational overview.</p>
                            {/* <a href="#" style={{ color: 'gray' }}>Show More</a> */}
                        </div>
                    </div>

                    <div class="feature">
                        <img src="https://img.icons8.com/ios/50/compass.png" alt="Customizable Analytics" />
                        <div>
                            <h3 style={{ color: "#2D3748" }}>Customizable Analytics</h3>
                            <p>Tailor analytics to your specific requirements, supporting strategic planning and operational reviews with precision.</p>
                            {/* <a href="#" style={{ color: 'gray' }}>Show More</a> */}
                        </div>
                    </div>

                    <div class="feature">
                        <img src="https://img.icons8.com/ios/50/light-on.png" alt="Actionable Intelligence" />
                        <div>
                            <h3 style={{ color: "#2D3748" }}>Actionable Intelligence</h3>
                            <p>Turn complex data into easy-to-understand insights that drive smarter, faster decision-making across your organization.</p>
                            {/* <a href="#" style={{ color: 'gray' }}>Show More</a> */}
                        </div>
                    </div>
                </div>
            </section>
            <section className="contactus-section" id='contactus'>
                <div className="contactus-container">
                    <div className="contactus-left">
                        <h2 className="contactus-heading">Get Started Today</h2>
                        <p className="contactus-description" >
                            Ready to take your operations to the next level?<br />
                            Reach out to us today and discover how PortOS can empower your business.
                        </p>
                    </div>
                    <form className="contactus-form">
                        <div className="contactus-row">
                            <div className="contactus-field">
                                <label>First name</label>
                                <input type="text" placeholder="First name" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                            </div>
                            <div className="contactus-field">
                                <label>Last name</label>
                                <input type="text" placeholder="Last name" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                            </div>
                        </div>

                        <div className="contactus-row">
                            <div className="contactus-field">
                                <label>Company name *</label>
                                <input type="text" placeholder="Company name" required value={companyName} onChange={(e) => setCompanyName(e.target.value)} />
                            </div>
                            <div className="contactus-field">
                                <label>Industry</label>
                                <input type="text" placeholder="Eg: Warehousing, Real-Estate" value={industry} onChange={(e) => setIndustry(e.target.value)} />
                            </div>
                        </div>

                        <div className="contactus-row">
                            <div className="contactus-field">
                                <label>Company Email *</label>
                                <input type="email" placeholder="Email" required value={companyEmail} onChange={(e) => setCompanyEmail(e.target.value)} />
                            </div>
                            <div className="contactus-field">
                                <label>Phone No</label>
                                <PhoneInput
                                    country={'in'}
                                    placeholder="Phone"
                                    inputStyle={{ width: "100%", height: "40px", borderRadius: "5px", border: "1px solid #ccc" }}
                                    value={fullPhoneNumber}
                                    onChange={(value, country) => {
                                        setFullPhoneNumber(value);
                                        setPhoneCountryCode(country.dialCode);
                                        setPhoneNumber(value.startsWith(country.dialCode)
                                            ? value.slice(country.dialCode.length)
                                            : value);
                                    }}
                                />
                            </div>
                        </div>
                        <div className='d-flex justify-content-center '>
                            <button type="submit" className="contactus-submit" onClick={handleSubmit}>Submit</button>
                        </div>
                    </form>
                </div>
            </section>
            <section class="smarter-decisions">
                <div class="smarter-left">
                    <h4 style={{ color: "#2D3748" }}>Insights That Drive</h4>
                    <h2><span class="bold">Smarter</span><br />Decisions</h2>
                </div>
                <div class="smarter-right">
                    <div className='image-row'>
                        <img src="images/icons/dashboardImage1.png" alt="Dashboard Image 1" />
                        <img src="images/icons/dashboardImage2.png" alt="Dashboard Image 2" />
                        <img src="images/icons/dashboardImage3.png" alt="Dashboard Image 3" />
                    </div>
                </div>
            </section>

            <PortosFooter />



        </>

    );
}
